import React, { useRef, useState, useEffect } from 'react';
import '../../../tailwind.css.js';

var Label = function (props) {
    var ref = useRef(null);
    var _a = useState(false), overflowX = _a[0], setOverflowX = _a[1];
    var _b = useState(false), overflowY = _b[0], setOverflowY = _b[1];
    useEffect(function () {
        if (ref.current && ref.current.parentElement) {
            setOverflowX((ref.current.parentElement.offsetWidth || 0) < ref.current.scrollWidth);
            setOverflowY((ref.current.parentElement.offsetHeight || 0) < ref.current.scrollHeight);
        }
    }, [props.label, props.className]);
    var title = (overflowX || overflowY) ? props.label : undefined;
    return React.createElement("span", { ref: ref, title: title, className: props.className }, props.label);
};

export { Label as default };
